import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { InputNumber, SelectPicker } from "rsuite";
// import "rsuite/dist/rsuite.min.css";
import { useTranslation } from "react-i18next";
import { ru, de } from "date-fns/locale";
import { useSelector } from "react-redux";
import axios from "axios";
import { useMediaQuery } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faCancel,
  faSearchMinus,
  faSearchPlus,
  faX,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { baseUrl } from "../data/baseUrl";
import { pointer } from "@testing-library/user-event/dist/cjs/pointer/index.js";
const BookingEngine = () => {
  const { t, i18n } = useTranslation();
  const getLocale = () => {
    switch (i18n.language) {
      case "ru":
        return ru;
      case "de":
        return de;

      default:
        return undefined; // Default to English if no match
    }
  };
  const { properties, loading, error } = useSelector(
    (state) => state.properties
  );
  const language = useSelector((state) => state.language.language);
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(max-width:1024px)");
  const [viewBooking, setViewBooking] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [childAges, setChildAges] = useState([]);
  const { layoutHotel } = useSelector((state) => state.layoutHotel);
  const [selectedProperty, setSelectedProperty] = useState("eghwaidakhtls");
  const [property, setProperty] = useState([0]);
  // Calculate maximum children based on adults
  const maxChildren = adults >= 2 ? 4 - adults : adults === 1 && 3 - adults;
  useEffect(() => {
    if (children > maxChildren) {
      setChildren(maxChildren);
      setChildAges(childAges.slice(0, maxChildren));
    }
  }, [adults, maxChildren, childAges, children]);
  // Handle the number of children change
  const handleChildrenChange = (value) => {
    const newValue = Math.max(0, Math.min(maxChildren, Number(value)));
    setChildren(newValue);

    if (newValue > childAges.length) {
      setChildAges([...childAges, ""]);
    } else if (newValue < childAges.length) {
      setChildAges(childAges.slice(0, newValue));
    }
  };

  // Handle age change for a specific child
  const handleAgeChange = (index, age) => {
    const newAges = [...childAges];
    newAges[index] = age;
    setChildAges(newAges);
  };

  const [checkInDate, setCheckInDate] = useState(new Date());
  const [checkOutDate, setCheckOutDate] = useState(
    new Date(checkInDate.getTime() + 24 * 60 * 60 * 1000)
  );
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(
    new Date(checkInDate.getTime() + 24 * 60 * 60 * 1000)
  );
  // const { hotelUrl } = useParams();

  const updateSelectedProperty = () => {
    if (layoutHotel?.hotelHeader) {
      setSelectedProperty(layoutHotel?.hotelHeader?.hotelPMSCode);
    }
  };
  useEffect(() => {
    setProperty(properties);

    updateSelectedProperty();
  }, [properties]);

  const handleChange = (event) => {
    setSelectedProperty(event.target.value);
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent the default form submission behavior

    try {
      const response = await axios.post(`${baseUrl}/api/PMS`, {
        propertyName: properties.find((p) => p.pmsCode === selectedProperty)
          ?.propertyName,
        pmsCode: selectedProperty,
        // arrival: startDate.toLocaleDateString(),
        // departure: endDate.toLocaleDateString(),
        arrival: formatDate(startDate),
        departure: formatDate(endDate),
        adults: adults.toString(),
        children: children.toString(),
        promoCode: promoCode,
        childrenAges1: childAges[0] ? childAges[0] : 0,
        childrenAges2: childAges[1] ? childAges[1] : 0,
      });

      window.location.href = response.data.bookingEngineUrl;
    } catch (error) {
      console.error("Failed to submit booking:", error);
      alert("Failed to submit booking");
    }
  };

  const [focus, setFocus] = useState(false);
  const [focusGuests, setGuestsFocus] = useState(false);
  // const pName = properties.find((p) => p.pmsCode === selectedProperty);

  return (
    <aside className="content-section no-spacing">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div
              onClick={() => setViewBooking(!viewBooking)}
              className="btn btn-secondary    "
              style={{
                display: isMobile ? "block" : "none",
                position: "fixed",
                bottom: 0,
                width: "100%",
                left: 0,
                borderRadius: 0,
                zIndex: 9999999999999,
              }}
            >
              <Link
                to="#."
                className="   d-flex justify-content-center align-items-center w-100 px-50 my-3"
              >
                <span className="text-light">
                  <FontAwesomeIcon
                    icon={viewBooking ? faSearchMinus : faSearchPlus}
                    className="me-2"
                  />
                  {!viewBooking && "Book Now"}
                </span>
              </Link>
            </div>
            <div
              className="hero__filter search-form"
              style={{ display: viewBooking || !isMobile ? "block" : "none" }}
            >
              {" "}
              <div className="searchForm -type-1 -blur-1 rounded-200 -text-white">
                <form className="searchForm__form searchForm__form-4">
                  <div className="searchFormItem js-select-control js-form-dd hotels">
                    <div
                      className="searchFormItem__button"
                      onClick={() => setFocus(!focus)}
                    >
                      <select
                        style={{
                          cursor: "pointer",
                        }}
                        className="form-select mx-auto   w-100"
                        value={selectedProperty}
                        onChange={handleChange}
                      >
                        {loading ? (
                          <option>{t("Loading...")}</option>
                        ) : error ? (
                          <option>
                            {t("Error")}: {error}
                          </option>
                        ) : (
                          property.map((property) => (
                            <option
                              key={property.pmsCode}
                              value={property.pmsCode}
                            >
                              {property.propertyName}
                            </option>
                          ))
                        )}
                      </select>

                      {focus ? (
                        <FontAwesomeIcon
                          icon={faX}
                          style={{
                            cursor: "pointer",
                            marginLeft: 0,
                            position: "absolute",
                            right: isMobile ? "9%" : "15%",
                            zIndex: "-1",
                          }}
                          className=" text-danger"
                        />
                      ) : (
                        <i
                          className="icon-arrow-down  "
                          style={{
                            cursor: "pointer",
                            marginLeft: 0,
                            position: "absolute",
                            right: isMobile ? "9%" : "15%",
                            zIndex: "-1",
                          }}
                        ></i>
                      )}
                    </div>
                  </div>

                  <div className="searchFormItem js-select-control js-form-dd js-calendar">
                    <div
                      className="searchFormItem__button"
                      style={{
                        cursor: "unset",
                        width: "280px",
                      }}
                    >
                      <DatePicker
                        selected={startDate}
                        onChange={(dates) => {
                          const [start, end] = dates;
                          setStartDate(start);
                          setEndDate(end);
                        }}
                        startDate={startDate}
                        endDate={endDate}
                        selectsRange
                        minDate={new Date()}
                        dateFormat="MMMM d, yyyy"
                        className="form-date text-light"
                        placeholderText={t("Select a date range")}
                        locale={getLocale()}
                      />
                      <div className="input-group-append">
                        <span
                          className="input-group-text  "
                          style={{ backgroundColor: "transparent", border: 0 }}
                        >
                          <FontAwesomeIcon
                            icon={faCalendarAlt}
                            className="text-light"
                            style={{
                              position: "absolute",
                              right: isMobile ? "8%" : "16%",
                              zIndex: "-1",
                            }}
                          />
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="searchFormItem js-select-control js-form-dd">
                    <div
                      className="searchFormItem__button"
                      onClick={() => setGuestsFocus(!focusGuests)}
                    >
                      <div className="js-select-control-chosen">
                        <>
                          {language === "ru"
                            ? "Гости"
                            : language === "en"
                            ? "Guests"
                            : "Gäste"}{" "}
                          <small>
                            ({adults}{" "}
                            {language === "ru"
                              ? "Взрослый"
                              : language === "en"
                              ? "Adult"
                              : "Erwachsene"}
                            {adults > 1 ? "s" : null}{" "}
                            {children > 0 ? (
                              <>
                                {" "}
                                & {children}{" "}
                                {language === "ru"
                                  ? "Ребенок"
                                  : language === "en"
                                  ? "Child"
                                  : "Kind"}
                              </>
                            ) : null}{" "}
                            )
                          </small>
                        </>
                      </div>
                      {focusGuests ? (
                        <FontAwesomeIcon
                          icon={faX}
                          className="ml-10 text-danger"
                        />
                      ) : (
                        <i className="icon-arrow-down ml-10"></i>
                      )}
                    </div>
                    <div
                      className={`searchFormItemDropdown -counter pe-0 ${
                        focusGuests ? "is-active" : null
                      } `}
                    >
                      <div className="searchFormItemDropdown__container">
                        <div className="searchFormItemDropdown__list">
                          <div className="form-group adult d-flex justify-content-lg-between mb-2 align-items-center">
                            <label>
                              {" "}
                              {language === "ru"
                                ? "Взрослый"
                                : language === "en"
                                ? "Adults"
                                : "Erwachsene"}{" "}
                            </label>
                            <div className="adult-mobile">
                              <button
                                type="button"
                                className="counter"
                                onClick={() => {
                                  adults > 1 && setAdults(adults - 1);
                                }}
                              >
                                -
                              </button>
                              <input
                                required
                                type="number"
                                className="fs-5"
                                placeholder={t("Adult Number")}
                                value={adults}
                                onChange={(e) =>
                                  setAdults(Math.max(1, Number(e.target.value)))
                                }
                                min="1"
                                max="4"
                              />
                              <button
                                type="button"
                                className="counter"
                                onClick={() =>
                                  adults < 4 && setAdults(adults + 1)
                                }
                              >
                                +
                              </button>
                            </div>

                            <InputNumber
                              className="adult-desktop d-flex text-center w-100 justify-content-center"
                              value={adults}
                              max={4}
                              min={1}
                              onChange={(value) => {
                                if (value !== null) {
                                  setAdults(Math.max(1, Number(value)));
                                }
                              }}
                            />
                          </div>
                          <div className="form-group child d-flex justify-content-lg-between align-items-center  mb-2">
                            <label>
                              {language === "ru"
                                ? "Ребенок"
                                : language === "en"
                                ? "Child"
                                : "Kind"}{" "}
                            </label>
                            <div className="child-mobile">
                              <button
                                type="button"
                                className="counter"
                                onClick={() => {
                                  children > 0 &&
                                    handleChildrenChange(children - 1);
                                }}
                              >
                                -
                              </button>
                              <input
                                required
                                type="number"
                                className="fs-5"
                                placeholder={t("Child Number")}
                                value={children}
                                onChange={(e) =>
                                  handleChildrenChange(e.target.value)
                                }
                                min="0"
                                max={maxChildren}
                              />
                              <button
                                type="button"
                                className="counter"
                                onClick={() =>
                                  children < maxChildren &&
                                  handleChildrenChange(children + 1)
                                }
                              >
                                +
                              </button>
                            </div>

                            <InputNumber
                              className="child-desktop d-flex text-center w-100 justify-content-center"
                              value={children}
                              max={maxChildren}
                              min={0}
                              onChange={(value) => {
                                if (value !== null) {
                                  handleChildrenChange(
                                    Math.max(0, Number(value))
                                  );
                                }
                              }}
                            />
                          </div>{" "}
                          {childAges.map((age, index) => (
                            <div
                              key={index}
                              className="form-group d-flex   mb-2  justify-content-between align-items-center"
                            >
                              <label>
                                {language === "ru"
                                  ? "Ребенок"
                                  : language === "en"
                                  ? "Child"
                                  : "Kind"}
                                {index + 1}{" "}
                                {language === "ru"
                                  ? "Возраст"
                                  : language === "en"
                                  ? "Age"
                                  : "Alter"}
                              </label>
                              <select
                                value={age}
                                onChange={(e) =>
                                  handleAgeChange(index, e.target.value)
                                }
                                className="child-age-dropdown form-select mt-1 mb-2 w-50"
                                style={{}}
                              >
                                {[...Array(12).keys()].map((num) => (
                                  <option key={num} value={num + 1}>
                                    {num + 1}
                                  </option>
                                ))}
                              </select>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <div className="searchForm__button">
                  <input
                    style={{
                      width: language === "de" ? "70px" : "50px",
                      height: "50px",
                    }}
                    className="button -accent-1 bg-accent-2 size-50 rounded-full"
                    type="submit"
                    value={
                      language === "ru"
                        ? "ИДТИ"
                        : language === "en"
                        ? "GO"
                        : "GEHEN"
                    }
                    onClick={handleSubmit}
                  />
                </div>
              </div>{" "}
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default BookingEngine;
